export enum ConfigKey {
  MPROLAB_CONTRACTS = 'mprolab-contracts'
}

export interface ConfigUpdateData {
  configKey: ConfigKey
  updatedAt: Date
}
